import React from "react"
import { LanguageCodenames, LocalizationString } from "../models/generated"
import { GraphQLNodes } from "../models/graphql-types"

interface ComponentProviderInterface {
  currentLanguage: LanguageCodenames
  localizedStrings: GraphQLNodes<LocalizationString>
  ContactDirectoryComponent: React.ReactNode
  ListingBeltSeriesComponent: React.ReactNode
  ListingBeltTypesComponent: React.ReactNode
  ListingLocationComponent: React.ReactNode
  ShippingFilesComponent: React.ReactNode
}

// make a new context
const ComponentContext = React.createContext<ComponentProviderInterface>(null)

// create the provider
const ComponentProvider = ({
  currentLanguage,
  children,
  localizedStrings,
  ContactDirectoryComponent,
  ListingBeltSeriesComponent,
  ListingBeltTypesComponent,
  ListingLocationComponent,
  ShippingFilesComponent,
}) => {
  return (
    <ComponentContext.Provider
      value={{
        currentLanguage,
        localizedStrings,
        ContactDirectoryComponent,
        ListingBeltSeriesComponent,
        ListingBeltTypesComponent,
        ListingLocationComponent,
        ShippingFilesComponent,
      }}
    >
      {children}
    </ComponentContext.Provider>
  )
}

export { ComponentContext, ComponentProvider }
